<template>
  <div class="form-group top_search">
    <h2>Search:</h2>
    <div
      class="searchbar"
      :class="[searchQuery !== '' ? 'input-group' : '']">
      <el-input
        placeholder="Search the PO# or Supplier"
        v-model="searchQuery"
        class="searchBar"
        @keyup.native="sendQuery">
        <el-button
          @click="sendClearQuery"
          slot="append"
          icon="close"
          v-if="searchQuery !== '' ">Clear search</el-button>
      </el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    existingSearchQuery: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  created() {
    this.searchQuery = this.existingSearchQuery;
  },
  methods: {
    sendQuery() {
      const query = this.searchQuery;
      window.setTimeout(() => {
        if (query === this.searchQuery) {
          this.$store.dispatch('setSearchQuery', this.searchQuery);
          this.$store.dispatch('getSearchedPOData');
        }
      }, 500);
    },
    sendClearQuery() {
      this.searchQuery = '';
      this.$store.dispatch('setSearchQuery', this.searchQuery);
      this.$store.dispatch('getSearchedPOData');
    },
  },
};
</script>

<style lang="scss" scoped>
.top_search {
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  .form-control {
    border-radius: 0;
  }
  .input-group-btn {
    button {
      border-radius: 3px;
    }
  }
}
.purchase-orders-summary {
  .searchbar {
    margin: 0;
    flex: 2;
    padding-left: 10px;
  }
}
.searchbar {
  width: 95.5%;
}

</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/partials/Searchbar.vue